import React from "react";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { initAppConfig } from "@config/appConfig";
import ViewportProvider from "@context/ViewportContext";
import App from "@components/App";

const {
    subscriberGroupId = 0,
    publicSubscriberGroup = 0,
    productTypeId = 0,
    cdnUrl = null,
} = document.getElementById("root").dataset;


const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";


if (!isLocalhost) {
    Sentry.init({
        dsn: "https://46c0969978134787b835ad495ca27b68@o1294733.ingest.us.sentry.io/6598565",
        integrations: [new BrowserTracing()],
        tracesSampleRate: 1.0,
    });
}

const config = {
    productTypeId: parseInt(productTypeId || "1"),
    publicSubscriberGroup: parseInt(publicSubscriberGroup || "0"),
    cdnUrl,
    subscriberGroupId: parseInt(subscriberGroupId || "25"),
};

initAppConfig(config);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <HelmetProvider>
        <ViewportProvider>
            <App />
        </ViewportProvider>
    </HelmetProvider>
);
